/**
 * Minúsculas, sem acento, sem espaço sobrando: `"  SÁBADO ÀS 10h "` vira
 * `"sabado as 10h"`, e `"  José   da Silva "` vira `"jose da silva"`.
 *
 * Existe no domínio, e não em cada chamador, porque quem compara texto
 * digitado no meio da rua compara **sempre desta forma**: o teclado do iPhone
 * no bolso raramente acentua, e a mesma pessoa escreve o nome de dois jeitos
 * em dois dias. Duas cópias desta função — uma para interpretar "sábado 10h",
 * outra para achar a ficha de "José" — divergiriam no dia em que uma delas
 * aprendesse o hífen ou o apóstrofo, e aí "José" e "Jose" voltariam a ser
 * duas pessoas só em um dos dois lugares.
 */
export function normalizarTexto(texto) {
    return texto
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, ' ');
}
//# sourceMappingURL=normalizar.js.map